import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';

const setShowSettingsHoverActionMutator: (showSettingsButton: any) => void = mutatorAction(
    'setShowSettingsHoverActionMutator',
    (showSettingsButton: any) => {
        getStore().showSettingsHoverAction = showSettingsButton;
    }
);

export default setShowSettingsHoverActionMutator;
